import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const SmartCreatePageEditorLoader: LoadableType<{
	contentId: string;
	iframeHostProduct?: string;
	sharedFeaturesInstrumentationId?: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-smartCreatePageEditorWrapper" */ './SmartCreatePageEditorDataWrapper.tsx'
			)
		).SmartCreatePageEditorDataWrapper,
});
